import { Injectable } from '@angular/core';
import { EntityConfig } from './entity-config';

/**
 * Central registry of replicable entity configurations.
 *
 * Each {@link BaseReplicableService} subclass that opts into replication
 * self-registers here in its constructor. The {@link RecoveryService} iterates
 * the registry to discover which entity types to restore — adding a new
 * replicable entity requires no changes here.
 */
@Injectable({ providedIn: 'root' })
export class EntityRegistry {
  private readonly entityConfigs = new Map<string, EntityConfig>();

  register(config: EntityConfig): void {
    this.entityConfigs.set(config.entityType, config);
  }

  getConfig(entityType: string): EntityConfig | undefined {
    return this.entityConfigs.get(entityType);
  }

  /** All registered configs, ascending by `syncPriority` (recovery order). */
  getAllConfigs(): EntityConfig[] {
    return Array.from(this.entityConfigs.values()).sort(
      (a, b) => a.syncPriority - b.syncPriority
    );
  }

  getReplicableTypes(): string[] {
    return Array.from(this.entityConfigs.keys());
  }
}
